"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarList = exports.Avatar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Layout = require("../Layout");

var _Image = require("../Image");

var _imageUrl = require("../../utils/imageUrl");

var avatarSizes = (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    nano: {
      width: '24px',
      height: '24px'
    },
    micro: {
      width: '32px',
      height: '32px'
    },
    tiny: {
      width: '40px',
      height: '40px'
    },
    small: {
      width: '48px',
      height: '48px'
    },
    medium: {
      width: '64px',
      height: '64px'
    },
    large: {
      width: '96px',
      height: '96px'
    },
    huge: {
      width: '128px',
      height: '128px'
    }
  }
});

var getSize = function getSize(size) {
  switch (size) {
    case 'nano':
      {
        return {
          width: 24,
          height: 24
        };
      }

    case 'micro':
      {
        return {
          width: 32,
          height: 32
        };
      }

    case 'tiny':
      {
        return {
          width: 40,
          height: 40
        };
      }

    case 'small':
      {
        return {
          width: 48,
          height: 48
        };
      }

    case 'medium':
      {
        return {
          width: 64,
          height: 64
        };
      }

    case 'large':
      {
        return {
          width: 96,
          height: 96
        };
      }

    case 'huge':
      {
        return {
          width: 128,
          height: 128
        };
      }

    default:
      return {
        width: 48,
        height: 48
      };
  }
};

var AvatarWrapper = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Avatar__AvatarWrapper",
  componentId: "s6rpu3-0"
})({
  display: 'inline-flex'
}, _styledSystem.space, avatarSizes);
var AvatarImg = (0, _styledComponents.default)(_Image.Image).withConfig({
  displayName: "Avatar__AvatarImg",
  componentId: "s6rpu3-1"
})(avatarSizes, _styledSystem.border, {
  boxSizing: 'content-box'
});
var Placeholder = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Avatar__Placeholder",
  componentId: "s6rpu3-2"
})({
  display: 'inline-flex',
  background: 'linear-gradient(120deg, rgba(232, 236, 242, 0.8) 0%, rgba(245, 247, 251, 0.6) 90%)'
}, _styledSystem.border, avatarSizes);

var Avatar = function Avatar(props) {
  var src = props.src,
      size = props.size,
      alt = props.alt,
      rest = (0, _objectWithoutProperties2.default)(props, ["src", "size", "alt"]);

  var isValidSrc = function isValidSrc() {
    if (rest.external) {
      return true;
    }

    try {
      (0, _imageUrl.getImageRouteFromUrl)(src);
      return true;
    } catch (_unused) {
      return false;
    }
  };

  return _react.default.createElement(AvatarWrapper, (0, _extends2.default)({
    size: size
  }, rest), src && isValidSrc() ? _react.default.createElement(AvatarImg, (0, _extends2.default)({
    src: src,
    borderRadius: [7],
    alt: alt,
    fixed: getSize(size)
  }, rest)) : _react.default.createElement(Placeholder, {
    size: size,
    borderRadius: [7]
  }));
};

exports.Avatar = Avatar;
Avatar.defaultProps = {
  src: '',
  alt: '',
  isStacked: false
};
var AvatarStack = (0, _styledComponents.default)('div').withConfig({
  displayName: "Avatar__AvatarStack",
  componentId: "s6rpu3-3"
})(["", " ", " ", " ", ""], _styledSystem.space, _styledSystem.flexbox, _styledSystem.layout, _styledSystem.position);

var AvatarList = function AvatarList(props) {
  var size = props.size,
      data = props.data;
  var count = data && data.slice(0, 5).length;
  return _react.default.createElement(AvatarStack, (0, _extends2.default)({
    position: "relative",
    alignItems: "center",
    display: "block"
  }, props), data && data.slice(0, 5).map(function (item, i) {
    return _react.default.createElement(Avatar, {
      external: item.external,
      key: item.id,
      fixed: getSize(size),
      src: item.imageUrl,
      hasBorder: true,
      marginRight: i < count - 1 ? '-12px' : 0,
      alt: "".concat(item.firstName, " ").concat(item.lastName)
    });
  }));
};

exports.AvatarList = AvatarList;
AvatarList.defaultProps = {
  data: null,
  size: 'medium'
};